import script from "./DCustomizableTableOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./DCustomizableTableOptions.vue?vue&type=script&setup=true&lang=js"

import "./DCustomizableTableOptions.vue?vue&type=style&index=0&id=50824086&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50824086"]])

export default __exports__